const kenticoForms = document.querySelectorAll('.kentico-form-widget-form form');

kenticoForms.forEach((formElement) => {
  formElement.addEventListener('submit', () => {
    const submitButtons = formElement.querySelectorAll('input[type="submit"]');

    submitButtons.forEach((submitButton) => {
      // After submit, the form should rerender, removing the disabled prop automatically
      submitButton.setAttribute('disabled', '');
    });
  });
});
